import { useEffect, useState } from 'react'

const useContainerWidth = ref => {
  const [width, setWidth] = useState(0)

  useEffect(() => {
    if (!ref.current)
      return () => null
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width))
    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [ref])

  return width
}

export default useContainerWidth
